import type { SceneContent } from '../../presentation/types';

export const technology: SceneContent = {
  id: 'technology',
  shortLabel: 'TECH',
  title: 'The Invisible Technology',
  seconds: 45,
  brand: 'moderta',
  bridgeIn: 'So what does that shared foundation actually look like?',
  atmosphere: (step) => ({ pattern: step === 3 ? 'drift' : 'ambient', density: step === 3 ? 0.3 : 0.14, opacity: 0.05, cameraZ: step === 3 ? 12.5 : 14.5 }),
  script: {
    title: 'The Invisible Technology',
    onScreen: ['INFRASTRUCTURE', 'INTEGRATIONS', 'INTELLIGENCE', 'PLATFORM', 'EXPERIENCE', 'COMPLEX UNDERNEATH.', 'SIMPLE WHERE IT MATTERS.'],
    visual: 'A stack of five layers builds from the bottom up: infrastructure, integrations, intelligence, platform, experience, each with its examples. The stack explodes apart to show how much sits underneath, then collapses back into one slim object with only the experience layer lit.',
    narration: [
      'At the bottom, infrastructure: cloud, containers, delivery pipelines and monitoring. Above it, integrations with APIs, GitHub, Jira, cloud services and the other systems our customers already use.',
      'Then intelligence, meaning AI, agents, automation and data processing, and the platform layer that holds workflows, security and business logic.',
      'And at the top, the part people actually touch: web, mobile and interactive interfaces.',
      'There is a lot of complexity underneath.',
      'But the person using the product should not have to see any of it. Complex underneath. Simple where it matters.',
    ],
    presenterNotes: [
      'Infrastructure and integrations arrive. Keep it quick.',
      'Intelligence and platform.',
      'Experience lands on top. "The part people actually touch."',
      'The stack explodes. "Complex underneath."',
      'It collapses; only the top stays lit. "Simple where it matters."',
    ],
  },
};
